<script>
  /**
   * Import required external libraries here, including all
   * the data we need for ArchieML.
   */
  import archieml from 'archieml';
  import https from 'https';

  /**
   * Child components go here
   */
  import Loading from './Loading.svelte';
  import Intro from './Intro.svelte';
  import Articles from './Articles.svelte';

  /**
   * Prop imports
   *
   * doc:  the google doc ID of the document that is used for
   * the copy. This component does not support authentication,
   * so make sure that the document is publicly accessible.
   */
  // eslint-disable-next-line
  export let doc;

  /**
   * Local variables
   */

  let data = {};
  let loadingContent = true;
  let error = false;
  let showArticlesPage;

  /**
   * Fetch google doc data with an https request. Note:
   * Although this code would be easier with request,
   * rollup is unable to compile request for the client.
   */
  const getData = () => {
    // const url = `https://docs.google.com/document/d/${doc}/export?format=txt`;
    const url = `https://activity.thenewslens.com/career-choices/${doc}.txt`;
    https.get(url, (resp) => {
      let ret = '';

       // A chunk of data has been received.
      resp.on('data', (chunk) => {
        ret += chunk;
      });

       // The whole response has been received. Load the result into data.
      resp.on('end', () => {
        data = Object.assign({}, data, archieml.load(ret));

        loadingContent = false;
      });
    }).on('error', (err) => {
      console.error(`Error: ${err.message}`);
      error = true;
    });
  };

  getData();

  const linkToArticles = type => {
    showArticlesPage = type;
  }
</script>

<style>
  .page {
    height: 100%;
    color: white;
  }
</style>

<div class="page">
  {#if loadingContent}
    <Loading />
  {:else}
    {#if !showArticlesPage}
      <Intro data={data} linkToArticles={linkToArticles} />
    {:else}
      <Articles data={data} linkToArticles={linkToArticles} type={showArticlesPage} />
    {/if}
  {/if}
</div>
